// library
import { ArAnticipation, ArReel, ArReels, ArSlotSounds } from '@aceroll/core/library';

// game-objects
import { Grid } from '../game-objects/slot/grid';

export const slotMachineConfig = {
	gridConstructor: Grid,
	reelsConstructor: ArReels,
	soundsConstructor: ArSlotSounds,
	grid: {
		// move this to the extra
		text: {
			fontType: 'bitmap',
			fontSize: 56,
			letterSpacing: 0,
			src: 'bitmap-win-line'
		},
		// and this
		winFormulaText: {
			fontType: 'bitmap',
			fontSize: 56,
			letterSpacing: 0,
			src: 'bitmap-win-line'
		},
		// and this
		anticipation: {
			anticipationConstructor: ArAnticipation,
			transforms: {
				position: {
					x: 0,
					y: 489
				},
				scale: {
					x: 0.745,
					y: 0.745
				}
			},
			default: {
				spine: {
					src: 'spine-anticipation',
					animations: {
						in: 'in',
						loop: 'idle',
						out: 'out'
					},
					skin: null
				}
			}
		},
		transforms: {
			landscape: {
				position: {
					x: 34,
					y: 69
				}
			},
			portrait: {
				position: {
					x: 34,
					y: 69
				}
			}
		},
		verticalGap: 2,
		horizontalGap: 8,
		radius: 21,
		cellsSize: {
			width: 182,
			height: 182
		},
		frameMask: {
			extraWidth: 200
		},
		reels: [
			{
				reelConstructor: ArReel,
				cellsAmount: 5,
				shift: {
					x: 0,
					y: 0
				},
				radius: {
					topLeft: 20,
					topRight: 0,
					bottomRight: 0,
					bottomLeft: 20
				}
			},
			{
				reelConstructor: ArReel,
				cellsAmount: 5,
				shift: {
					x: 0,
					y: 0
				},
				radius: {
					topLeft: 0,
					topRight: 0,
					bottomRight: 0,
					bottomLeft: 0
				}
			},
			{
				reelConstructor: ArReel,
				cellsAmount: 5,
				shift: {
					x: 0,
					y: 0
				},
				radius: {
					topLeft: 0,
					topRight: 0,
					bottomRight: 0,
					bottomLeft: 0
				}
			},
			{
				reelConstructor: ArReel,
				cellsAmount: 5,
				shift: {
					x: 0,
					y: 0
				},
				radius: {
					topLeft: 0,
					topRight: 0,
					bottomRight: 0,
					bottomLeft: 0
				}
			},
			{
				reelConstructor: ArReel,
				cellsAmount: 5,
				shift: {
					x: 0,
					y: 0
				},
				radius: {
					topLeft: 0,
					topRight: 20,
					bottomRight: 20,
					bottomLeft: 0
				}
			}
		]
	},
	behaviour: {
		spin: {
			reelStartDelays: {
				default: [
					0,
					150,
					250,
					300,
					350
				],
				turbo: [
					0,
					100,
					150,
					200,
					250
				],
				superTurbo: [
					0,
					0,
					0,
					0,
					0
				],
				lightingTurbo: [
					0,
					0,
					0,
					0,
					0
				]
			},
			reelStopDelays: {
				default: [
					0,
					250,
					450,
					600,
					700
				],
				turbo: [
					0,
					150,
					270,
					360,
					420
				],
				superTurbo: [
					0,
					0,
					0,
					0,
					0
				],
				lightingTurbo: [
					0,
					0,
					0,
					0,
					0
				]
			},
			transition: {
				default: {
					minDuration: 800,
					stepDuration: 25,
					startDuration: 75,
					endDuration: 700,
					startEase: 'linear',
					endEase: 'back.out(4)'
				},
				turbo: {
					minDuration: 400,
					stepDuration: 18,
					startDuration: 54,
					endDuration: 504,
					startEase: 'linear',
					endEase: 'back.out(1.7)'
				},
				superTurbo: {
					minDuration: 0,
					stepDuration: 12,
					startDuration: 150,
					endDuration: 48,
					startEase: 'linear',
					endEase: 'back.out(0.7)'
				},
				lightingTurbo: {
					minDuration: 0,
					stepDuration: 8,
					startDuration: 150,
					endDuration: 36,
					startEase: 'linear',
					endEase: 'linear'
				}
			}
		},
		anticipation: {
			transition: {
				default: {
					minDuration: 1200,
					stepDuration: 16,
					startEase: 'linear',
					endEase: 'back.out(4)'
				},
				turbo: {
					minDuration: 800,
					stepDuration: 12,
					startEase: 'linear',
					endEase: 'back.out(1.7)'
				},
				superTurbo: {
					minDuration: 0,
					stepDuration: 12,
					startEase: 'linear',
					endEase: 'back.out(1.7)'
				},
				lightingTurbo: {
					minDuration: 0,
					stepDuration: 8,
					startEase: 'linear',
					endEase: 'linear'
				}
			}
		}
	},
	sounds: {
		anticipation: 'reel_antisipation',
		roll_spin: null,
		start: {
			default: null,
			turbo: null,
			superTurbo: null,
			lightingTurbo: null
		},
		finish: {
			default: null,
			turbo: null,
			superTurbo: null,
			lightingTurbo: null
		},
		reels: [
			{
				start: {
					default: 'slot_spin_roll',
					turbo: 'slot_spin_roll',
					superTurbo: null,
					lightingTurbo: null
				},
				finish: {
					default: 'reelstop_1',
					turbo: 'reelstop_1',
					superTurbo: null,
					lightingTurbo: null
				}
			},
			{
				start: {
					default: 'slot_spin_roll',
					turbo: 'slot_spin_roll',
					superTurbo: null,
					lightingTurbo: null
				},
				finish: {
					default: 'reelstop_2',
					turbo: 'reelstop_2',
					superTurbo: null,
					lightingTurbo: null
				}
			},
			{
				start: {
					default: 'slot_spin_roll',
					turbo: 'slot_spin_roll',
					superTurbo: null,
					lightingTurbo: null
				},
				finish: {
					default: 'reelstop_3',
					turbo: 'reelstop_3',
					superTurbo: null,
					lightingTurbo: null
				}
			},
			{
				start: {
					default: 'slot_spin_roll',
					turbo: 'slot_spin_roll',
					superTurbo: null,
					lightingTurbo: null
				},
				finish: {
					default: 'reelstop_4',
					turbo: 'reelstop_4',
					superTurbo: null,
					lightingTurbo: null
				}
			},
			{
				start: {
					default: 'slot_spin_roll',
					turbo: 'slot_spin_roll',
					superTurbo: 'slot_spin_roll',
					lightingTurbo: 'slot_spin_roll'
				},
				finish: {
					default: 'reelstop_5',
					turbo: 'reelstop_5',
					superTurbo: 'reelstop_5',
					lightingTurbo: 'reelstop_5'
				}
			}
		]
	},
	defaults: {
		symbols: {
			default: [
				['1', '4', '5', '1', '6'],
				['5', '6', '7', '3', '5'],
				['6', '7', '8', '9', '1'],
				['5', '4', '3', '9', '2'],
				['2', '5', '2', '4', '3']
			],
			fs: [
				['1', '4', '5', '1'],
				['5', '6', '7', '3'],
				['6', '7', '8', '9'],
				['5', '4', '3', '9'],
				['2', '5', '2', '4']
			]
		},
		fakeSymbols: {
			default: [
				['1', '4', '5', '1', '6'],
				['5', '6', '7', '3', '5'],
				['6', '7', '8', '9', '1'],
				['5', '4', '3', '9', '2'],
				['2', '5', '2', '4', '3']
			],
			fs: [
				['1', '4', '5', '1', '6'],
				['5', '6', '7', '3', '5'],
				['6', '7', '8', '9', '1'],
				['5', '4', '3', '9', '2'],
				['2', '5', '2', '4', '3']
			]
		}
	}
}
